<template>
  <div class="navbar-expandable-menu">
    <div
      v-show="dropdown !== 'closed'"
      class="width-100 absolute z-100 bg-light-gray"
      @mouseleave="closeDropDown($event)"
    >
      <div class="container">
        <login-menu v-if="dropdown === 'sign-in'" @close-dropdown="closeDropDown" />
        <apply-menu v-if="dropdown === 'sign-up'" @close-dropdown="closeDropDown" />
        <shop v-if="dropdown === 'category'" :data="categories" @close-dropdown="closeDropDown" />
        <refer v-if="dropdown === 'refer'" @close-dropdown="closeDropDown" />
      </div>
    </div>
  </div>
</template>
<script>
import LoginMenu from "@/components/navigation/dropdownMenus/LoginMenu/LoginMenu.vue";
import ApplyMenu from "@/components/navigation/dropdownMenus/Apply";
import Shop from "@/components/navigation/dropdownMenus/Shop/Shop.vue";
import Refer from "@/components/navigation/refer/refer.vue";
import { mapGetters } from "vuex";

export default {
  name: "Dropdown",
  components: { Shop, LoginMenu, ApplyMenu, Refer },
  computed: {
    ...mapGetters({
      dropdown: "navigation/dropdownState",
    }),
  },
  props: ["categories"],
  data: () => {
    return {
      isMenuOpen: false,
    };
  },

  methods: {
    closeDropDown(event) {
      if (event?.type === "mouseleave" && this.dropdown === "sign-in") {
        return;
      }
      //prevent close if user hovers into navbar
      if (event?.relatedTarget && (event.relatedTarget.id === "navbar" || event.relatedTarget.id === "menu")) {
        return;
      }
      this.$store.dispatch("navigation/setDropdownType", "closed");
    },
  },
};
</script>

<style lang="scss" scoped></style>
